module.exports = __webpack_public_path__ + "img/main.md.fa450510.jpg";